import {Toolbar} from './workflow/toolbar/workflow-toolbar';
import {ReactFlowProvider} from '@xyflow/react';
import TaskWorkflow from './workflow/workflow';
import Loader from '@/components/Loader';
import {BaseKey} from '@refinedev/core';
import {useLoadTaskWorkflow} from './workflow/hooks/useLoadTaskWorkflow';
import useMyResourceParams from '@/hooks/refinedev/useMyResourceParams';
import {BreadcrumbsType, useSetCustomBreadcrumb} from '@/hooks/useBreadcrumbs';
import {useMemo} from 'react';

const TaskEditWorkflow = () => {
  const m = useMyResourceParams();
  const {loadWorkflow} = useLoadTaskWorkflow(m.id);

  const breadcrumbs: BreadcrumbsType[] = useMemo(() => {
    const data = loadWorkflow.data;
    if (!data) return [];
    const output = [{path: '/tasks', label: ''}]; // empty to hide

    if (data.project) {
      output.push({
        path: `/projects/${data.project.id}/editwf`,
        label: `Dự án [${data.project.name}]`,
      }); // up to project
    }
    output.push({path: `/tasks/${m.id}/editwf`, label: `Lưu đồ công việc [${data.name}]`});

    return output;
  }, [loadWorkflow.data]);
  
  useSetCustomBreadcrumb(breadcrumbs);

  if (loadWorkflow.isLoading) return <Loader />;

  return (
    <ReactFlowProvider>
      <div className="flex flex-col h-full w-full">
        <Toolbar resource="tasks" id={String(m.id)} record={loadWorkflow.data} />
        <TaskWorkflow className="h-full w-full" />
      </div>
    </ReactFlowProvider>
  );
};

export default TaskEditWorkflow;
